import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-85913002"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "coffee" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Influence of Electric Taste"),
  /*#__PURE__*/_createElementVNode("p", { style: {"width":"80vw","text-align":"center","margin-bottom":"4vw"} }, " This reserach paper was the culmination of multiple years of work, focused on the science of flavor and how to influence it. It involved many areas of engineering, such as mechanical, electrical, and bio-chemical. I am proud to be a co-author on this work. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://drive.google.com/file/d/1cEcI_jVDroXyLZV73wZ1r67m8-J05GEs/preview",
  width: "80%",
  height: "800",
  allow: "autoplay"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { ref, computed } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "VirtualCoffee",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}
}

})